import { render, staticRenderFns } from "./TenentForgotPassword.vue?vue&type=template&id=1da2323b&scoped=true"
import script from "./TenentForgotPassword.vue?vue&type=script&lang=js"
export * from "./TenentForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./TenentForgotPassword.vue?vue&type=style&index=0&id=1da2323b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da2323b",
  null
  
)

export default component.exports